export default __webpack_public_path__ + "static/media/EM0690.34I-22669_-15168_0.967cc303.jpg";